var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.056,
    height: 18.055,
    viewBox: "0 0 18.056 18.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favorite",
    transform: "translate(-1.181 -1.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M13.549,16.206a1.477,1.477,0,0,1-.731-.2l-1.732-1a.207.207,0,0,0-.208,0l-1.732,1A1.466,1.466,0,0,1,7,14.352l.533-1.94a.207.207,0,0,0-.058-.207L6.211,11a1.465,1.465,0,0,1,1-2.527h1.3a.208.208,0,0,0,.183-.11l.99-1.833a1.465,1.465,0,0,1,2.578,0h0l.99,1.834a.208.208,0,0,0,.183.11h1.3a1.465,1.465,0,0,1,1,2.527L14.486,12.2a.207.207,0,0,0-.058.207l.533,1.94a1.467,1.467,0,0,1-1.413,1.854Zm-2.566-2.474a1.459,1.459,0,0,1,.73.2l1.732.991a.2.2,0,0,0,.233-.016.2.2,0,0,0,.074-.221l-.533-1.939a1.465,1.465,0,0,1,.4-1.451l1.269-1.205a.2.2,0,0,0,.05-.229.2.2,0,0,0-.191-.128h-1.3a1.466,1.466,0,0,1-1.289-.768l-.989-1.834c-.1-.192-.265-.192-.368,0L9.811,8.959a1.466,1.466,0,0,1-1.289.768H7.216a.2.2,0,0,0-.194.131.2.2,0,0,0,.05.23l1.269,1.2a1.465,1.465,0,0,1,.407,1.447l-.533,1.939a.2.2,0,0,0,.074.221.2.2,0,0,0,.233.016l1.732-1A1.458,1.458,0,0,1,10.983,13.731Z",
    transform: "translate(-0.745 -0.746)",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M10.237,19.236a9.027,9.027,0,1,1,4.445-1.186.628.628,0,0,1-.619-1.093,7.726,7.726,0,1,0-3.826,1.024.628.628,0,1,1,0,1.256Z",
    fill: "#8d8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M13.857,22.256a.628.628,0,0,1-.125-1.243,5.619,5.619,0,0,0,.866-.239.628.628,0,0,1,.445,1.172,6.864,6.864,0,0,1-1.059.3.662.662,0,0,1-.127.014Z",
    transform: "translate(-1.963 -3.187)",
    fill: "#8d8d8d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.2efbac393b5c2e655e380eebc51de2f0.svg";
export { ForwardRef as ReactComponent };